import React from 'react'
import {Modal, ModalHeader, ModalBody} from 'reactstrap'

class ModalItemLabel extends React.Component {
    render() {
        const {itemLabel, isOpen, toggle, className} = this.props

        return (
            <div>
                <Modal isOpen={isOpen} toggle={toggle} className={className}>
                    <ModalHeader toggle={toggle}>Image Item Label</ModalHeader>
                    <ModalBody>
                        {
                            itemLabel ? <img src={itemLabel} alt="image item label"/> : ''
                        }
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}

export default ModalItemLabel
